@import "~/styles/variables";
@import "~/styles/v1/_variables.scss"; // TODO: Remove this when we're done with v1 styles

/*
 * NOTE:
 * These need fully reset styles for now thanks to our global v1 styles.
 * I've used @csstools/normalize.css as a reference for this,
 * as that's what we'll use for our CSS Normalize eventually.
 * See: https://create-react-app.dev/docs/adding-css-reset/
 * See: https://github.com/csstools/postcss-normalize
 * See: https://github.com/csstools/normalize.css/blob/master/normalize.css
 */

// Normalize reset
.Button {
  -webkit-appearance: button;
  margin: 0;
  overflow: visible;
  text-transform: none;
}

// Actual styles

$button-size-s: 30px;
$button-size-m: 38px;
$button-size-l: 50px;

.Button {
  @include border;
  @include font-color("dark");
  @include font-family("sans");
  @include font-size("s");
  @include font-weight("semibold");
  @include transition;
  align-items: center;
  background: $color-white;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: $button-size-m;
  line-height: inherit;
  padding: 0 $space-s;
  position: relative;
  text-decoration: none;

  // States

  &:focus {
    outline: 0;
  }

  &.disabled {
    cursor: pointer;
    opacity: 0.65;
    pointer-events: none;
  }

  &.loading {
    .Content {
      visibility: hidden;
    }

    .LoadingIcon {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  // Internals

  .Content {
    align-items: center;
    display: flex;
  }

  .Icon_prefix,
  .Icon_suffix {
    padding-bottom: 1px;
  }

  .Icon_prefix {
    margin-right: $space-s;
  }

  .Icon_suffix {
    margin-left: $space-s;
  }

  // Sizes

  &.s {
    height: $button-size-s;
    padding: 0 $space-s;

    .Icon_prefix,
    .Icon_suffix {
      padding-bottom: 0;
    }

    .Icon_prefix {
      margin-right: $space-xs;
    }

    .Icon_suffix {
      margin-left: $space-xs;
    }
  }

  &.l {
    @include font-size("m");
    height: $button-size-l;
    padding: 0 $space-m;
  }

  &.full {
    width: 100%;

    .Content {
      justify-content: center;
    }
  }

  // Appearances

  &.outline {
    &:focus,
    &:hover {
      @include shadow("subtle", false);
    }
  }

  &.silent {
    background: transparent;
    border-color: transparent;

    &:focus,
    &:hover {
      background: $color-grey-light;
    }
  }

  &.transparent {
    background: transparent;

    &:focus,
    &:hover {
      background: $border-color;
    }
  }

  &.dark {
    background: transparent;
    border-color: transparent;
    color: $font-color-reverse;

    &:focus,
    &:hover {
      background: $color-charcoal-light;
      border-color: $color-charcoal-light;
    }
  }

  &.sidebar {
    background: transparent;
    border-color: transparent;
    color: $font-color-reverse;

    &:focus,
    &:hover {
      background: rgb(89 94 134 / 0.3); // @todo: replace when we use v2 colors
      border-color: transparent; // @todo: replace when we use v2 colors
    }
  }

  @each $name, $val in $colors-purpose {
    &.#{$name} {
      background: map-get($colors-purpose, $name);
      border-color: map-get($colors-purpose, $name);
      color: map-get($colors-purpose-text, $name);

      &:focus,
      &:hover {
        background: map-get($colors-purpose-dark, $name);
        border-color: map-get($colors-purpose-dark, $name);
      }
    }
  }

  // Other

  &.marginLeft {
    margin-left: $space-xs;
  }

  &.marginRight {
    margin-right: $space-xs;
  }

  &.square {
    justify-content: center;
    padding: 0;
    width: $button-size-m;

    &.s {
      padding: 0;
      width: $button-size-s;
    }

    &.l {
      padding: 0;
      width: $button-size-l;
    }
  }
}
